// *** url di test
// https://www.serviceapplications.net/_car/_r/ecu-helper/computer/add?b=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2NvZGUiOiI5OTdDREM4ODNEMkEyNjZEOEM0MkI5MjZDQ0YxMTUzN0VDQUU4NzI5NUE1RTBERTZBQzlCQUY1MDU0OTYzMDE5IiwiaXNzIjoic2VydmljZWFwcGxpY2F0aW9ucy5uZXQiLCJleHAiOjE3MzI3OTk5OTIsInByb2dyYW1fc2VsZWN0b3IiOiJvbWVnYXNfREkxMjAiLCJwcm9ncmFtX25hbWUiOiJPbWVnYXNESTEyMCJ9.c_e-Xe4GJqC_FV7-SVKlHoyUO_B7gjzBW5FGdQQ4_aecH8_vZMGQxOzAXyUMBgdvrXIHQ2wKo6aqhSybyON58Ho6A9dG6-uo3qUljlq8sxHmdmCt0XzPgESr_Fuepc_bXtah-meDMGPfhp67HYTaL9_zx8xgmKwsRFCBfz40zk7epQy4a15VfSbo_UVuo98QvZfkl9FWSLhw_rhHIOjK375SxuJYa0hxoDR1uq8dsNiAvvHewZrfgZoYbXfEN034QA_qVAF8alPhoUm3m7GigilNyxAd-zYCcGHbXaqSBkigaeLL0g01HER6jpoEqUUsKrapr-GMkcitaVFngUBWEKhbPfAuYhxdu3ReJnzTGMr2RTNj9DH-DRduWwI8FfSR2TVbrex3GEc2XQzz11lKOkN2PidlEDSZy0DsnUcOuliyI4LHu3b9e0s5VR8RNmLDDHt3w7pdcQ50On0DDnax9O3qdGm0aezTA03OwlHaIM_1L7_vQx4lhkwhPoPppXKYcGSeXYT1CzKStM-arL_rFl5wBsJFt27S3lMCNyV9n4ZYlRrAEeCJEnPuw50zxRd6qzkiSa1eRUwJFJtV4GlqIsAbZziwjsbJLXvhN9FGUtWt6JJVJX6a4YhgWf5Cnda-6vKK-IcmYAcjI9CYGgSK9CTpTm0lhiLe32Tu_5sz6bg
// http://localhost:3000/_car/_r/ecu-helper/computer/add?b=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2NvZGUiOiI5OTdDREM4ODNEMkEyNjZEOEM0MkI5MjZDQ0YxMTUzN0VDQUU4NzI5NUE1RTBERTZBQzlCQUY1MDU0OTYzMDE5IiwiaXNzIjoic2VydmljZWFwcGxpY2F0aW9ucy5uZXQiLCJleHAiOjE3MzI3OTk5OTIsInByb2dyYW1fc2VsZWN0b3IiOiJvbWVnYXNfREkxMjAiLCJwcm9ncmFtX25hbWUiOiJPbWVnYXNESTEyMCJ9.c_e-Xe4GJqC_FV7-SVKlHoyUO_B7gjzBW5FGdQQ4_aecH8_vZMGQxOzAXyUMBgdvrXIHQ2wKo6aqhSybyON58Ho6A9dG6-uo3qUljlq8sxHmdmCt0XzPgESr_Fuepc_bXtah-meDMGPfhp67HYTaL9_zx8xgmKwsRFCBfz40zk7epQy4a15VfSbo_UVuo98QvZfkl9FWSLhw_rhHIOjK375SxuJYa0hxoDR1uq8dsNiAvvHewZrfgZoYbXfEN034QA_qVAF8alPhoUm3m7GigilNyxAd-zYCcGHbXaqSBkigaeLL0g01HER6jpoEqUUsKrapr-GMkcitaVFngUBWEKhbPfAuYhxdu3ReJnzTGMr2RTNj9DH-DRduWwI8FfSR2TVbrex3GEc2XQzz11lKOkN2PidlEDSZy0DsnUcOuliyI4LHu3b9e0s5VR8RNmLDDHt3w7pdcQ50On0DDnax9O3qdGm0aezTA03OwlHaIM_1L7_vQx4lhkwhPoPppXKYcGSeXYT1CzKStM-arL_rFl5wBsJFt27S3lMCNyV9n4ZYlRrAEeCJEnPuw50zxRd6qzkiSa1eRUwJFJtV4GlqIsAbZziwjsbJLXvhN9FGUtWt6JJVJX6a4YhgWf5Cnda-6vKK-IcmYAcjI9CYGgSK9CTpTm0lhiLe32Tu_5sz6bg
// Register your copy of OmegasDI120
// User code: 997CDC883D2A266D8C42B926CCF11537ECAE87295A5E0DE6AC9BAF5054963019

// ****************************************************************************
// ****************************************************************************
// ****************************************************************************

import React, { useState } from 'react';
import SelectBox from 'devextreme-react/select-box';
import { Paper, Chip, ButtonGroup, Button } from '@mui/material';
import { Link as RouterLink, MemoryRouter, useNavigate, Link, Navigate, useParams, useSearchParams } from 'react-router-dom';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Form, { ButtonItem, GroupItem, SimpleItem, Label, CompareRule, EmailRule, PatternRule, RangeRule, RequiredRule, StringLengthRule, AsyncRule, Item } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import 'devextreme-react/text-area';
import 'devextreme-react/select-box';
import 'devextreme-react/autocomplete';
import utils from '../utils';
import ServiceUserForm from './ServiceUserForm';
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';
import TextBox from 'devextreme-react/text-box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

// ************************************************************
// ************************************************************
// ************************************************************
/*
    da qui lo genero:
    https://www.serviceapplications.net/_test/TestAddComputer.aspx?u=FaI2611bwMpRbbTEOIZ4qnU7dv%2FFxZa93%2FjsOYzkWyEZ5A3Oypr7JAu2%2FkdZojFx0vpNV1NMmpQo%2BkEfoqZo4rv0%2FxIeG4rLOJ4zpcuTdvo%3D&v=XO13mulnrzAkZBrE%2FOB6Eg%3D%3D&p=omegas_landi&n=PC1161

    lo decodifico con insomnia, post json di
    https://www.serviceapplications.net/_car/user/api/ComputerInfo
    {
      "bearer": xxx
    }
    xxx := output di TestAddComputer

    qui lo provo in react app
    http://localhost:3000/_car/_r/ecu-helper/computer/add?b=xxx
    http://localhost:3000/_car/_r/ecu-helper/computer/add?b=_DEMO_

*/
// ************************************************************
// ************************************************************
// ************************************************************

class LoginComp extends React.Component {
  constructor(props) {
    super(props);
    this.form = React.createRef()
  }
  componentDidMount() {
  }
  render() {
    return (
      <form>
        <div>
          <p>To register the software you need to access your account.</p>
          <p>Enter your login information below.</p>
          <br />
          <p>Don't you have the information to access your account? {' '}            
            <Button
              size="small"
              onClick={() => {
                this.props.btn_create_account_click()
              }}
              >
              Create a new account
            </Button>
          </p>
          <p>
            Forgot something? {' '}
            <Button
              href="../service/user/reset/password" 
              target="_blank"
              size="small"
              >
              Click here to reset your password
            </Button>
          </p>
        </div>
        <br />
        <Form
          ref={this.form}
          formData={this.props.user}
          readOnly={false}
          showColonAfterLabel={true}
          //showValidationSummary={true}
          labelLocation="left"
          minColWidth={300}
          colCount={2}
          validationGroup="userDataValidationGroup" >

          {this.credentialFormItems()}

        </Form>
        {this.renderButtons()}
      </form>
    )
  }

  credentialFormItems() {
    return (
      <GroupItem caption="Credentials">

        {/* USERNAME */}
        <SimpleItem
          dataField="username"
          editorType="dxTextBox"
          editorOptions={{
            readOnly: false,
          }} >
          <StringLengthRule
            min={5}
            message="Username must have at least 5 symbols" />
          <RequiredRule message="Username is required" />
          <PatternRule
            message="Allowed letters and numbers only"
            pattern={/^[a-zA-Z0-9]*$/} />
        </SimpleItem>

        {/* PASSWORD */}
        <SimpleItem
          dataField="password"
          editorType="dxTextBox"
          editorOptions={{
            mode: 'password',
          }} >
          <StringLengthRule
            min={8}
            message="Password must have at least 8 symbols" />
          <RequiredRule message="Password is required" />
          <PatternRule
            message="Allowed letters and numbers only"
            pattern={/^[a-zA-Z0-9]*$/} />
        </SimpleItem>

      </GroupItem>
    )
  }

  renderButtons() {
    return (
      <>
        <Stack direction="row" spacing={1}>          
          <Button
            variant="contained"
            size="medium"
            onClick={() => {
              var res = this.form.current.instance.validate()
              if (res.isValid) {
                this.props.btn_submit_click()
              } else {
                console.log(res)
              }
            }} >
            SUBMIT
          </Button>
        </Stack>
        <br />
      </>
    )
  }
}

class AddToUserDialogComp extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (      
      <Dialog
        open={this.props.open}
        onClose={() => this.props.handle_cancel()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {this.props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {this.props.text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.props.handle_cancel()}>NO</Button>
          <Button onClick={() => this.props.handle_confirm()} autoFocus>
            YES
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

class AddToUserComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      dialogTitle: "ARE YOU SURE?",
      dialogText: "",
      dialogHandleConfirm: undefined,
    }
    this.form1 = React.createRef()
    this.form2 = React.createRef()
  }
  dialogHandleCancel() {
    this.setState({
      dialogOpen: false,
    })
  }
  dialogEmailHandleConfirm() {
    console.log("email confirmed")
    this.setState({
      dialogOpen: false,
    })
    this.props.btn_add_to_email_click()
  }
  dialogUsernameHandleConfirm() {
    console.log("username confirmed")
    this.setState({
      dialogOpen: false,
    })
    this.props.btn_add_to_username_click()
  }
  addToUserForms() {
    return (
      <>
        <br />
        <br />

        <p>If you want to use a different user, fill one of the forms below.</p>
      
        <br />

          <Form
            ref={this.form1}
            formData={this.props.add_to}
            readOnly={false}
            showColonAfterLabel={true}
            labelLocation="left"
            minColWidth={300}
            colCount={2}
            validationGroup="validationGroup1" >
              
            <GroupItem caption="Add to User by Username">
              {/* USERNAME */}
              <SimpleItem
                dataField="username"
                editorType="dxTextBox"
                editorOptions={{
                  readOnly: false,
                  inputAttr: {
                    autocomplete: "new-username",
                  },
                }} >
                <StringLengthRule
                  min={5}
                  message="Username must have at least 5 symbols" />
                <RequiredRule message="Username is required" />
                <PatternRule
                  message="Allowed letters and numbers only"
                  pattern={/^[a-zA-Z0-9]*$/} />
              </SimpleItem>
            </GroupItem>

          </Form>
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              size="medium"
              onClick={() => {
                var res = this.form1.current.instance.validate()
                if (res.isValid) {
                  this.setState({
                    dialogOpen: true,
                    dialogTitle: this.props.add_to.username,
                    dialogText: "Confirm?",
                    dialogHandleConfirm: this.dialogUsernameHandleConfirm.bind(this),
                  })
                } 
              }} >
              SUBMIT
            </Button>
          </Stack>

        <br />     
        <br />     

          <Form
            ref={this.form2}
            formData={this.props.add_to}
            readOnly={false}
            showColonAfterLabel={true}
            labelLocation="left"
            minColWidth={300}
            colCount={2}
            validationGroup="validationGroup2" >
              
            <GroupItem caption="Add to User by Email">
              {/* EMAIL */}              
              <SimpleItem
                dataField="email"
                editorType="dxTextBox"
                editorOptions={{
                  mode: 'email',
                  readOnly: false,
                  inputAttr: {
                    autocomplete: "new-username",
                  },
                }} >
                <RequiredRule message="Email is required" />
                <EmailRule message="Email is invalid" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <Stack direction="row" spacing={1}>
            <Button
              variant="contained"
              size="medium"
              onClick={() => {
                var res = this.form2.current.instance.validate()
                if (res.isValid) {
                  this.setState({
                    dialogOpen: true,
                    dialogTitle: this.props.add_to.email,
                    dialogText: "Confirm?",
                    dialogHandleConfirm: this.dialogEmailHandleConfirm.bind(this),
                  })
                } 
              }} >
              SUBMIT
            </Button>
          </Stack>
      </>
    )
  }
  render() {
    // SOLO GLI ADMIN POSSONO ASSOCIARE L'UTENTE A CHI VOGLIONO !!!
    var hide_add_to_user_forms = true
    if (this.props.user.is_admin) {
      hide_add_to_user_forms = false
    }
    return (
      <>        
        <AddToUserDialogComp
          title={this.state.dialogTitle}
          text={this.state.dialogText}
          open={this.state.dialogOpen}
          handle_cancel={this.dialogHandleCancel.bind(this)}
          handle_confirm={this.state.dialogHandleConfirm}
          />
        
        <p>You are signed in with this username: <strong>{this.props.user.username}</strong></p>
        <p>If you want to associate the new software user code to this username, click this button:</p>
        <p>
          <Button
            variant="contained"
            size="medium"
            onClick={() => {
              this.props.btn_add_to_current_user_click()
            }}
            >
            Add to current user
          </Button>              
        </p>          
      
        {!hide_add_to_user_forms && this.addToUserForms()}
        
      </>
    )
  }
}

export const ComputerAddComponentWrapper = (props) => {
  //const { bearer_value } = useParams()
  const [searchParams, setSearchParams] = useSearchParams();
  var bearer_value = searchParams.get("b")
  const navigate = useNavigate()
  //console.log(searchParams.get("b"))
  return <ComputerAdd 
    bearer_value={bearer_value} 
    navigate={navigate} 
    {...props} />
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  // https://stackoverflow.com/questions/41928567/div-cannot-appear-as-a-descendant-of-p
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'} variant={'body2'}>{children}</Typography>
        </Box>
      )}
    </div>
  )
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}
function a11yProps(index) { return { id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}`, } }
class ComputerAdd extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      errorMessage: undefined,
      completed: false,
      selectedTabIndex: 0,
      resellersRows: [],
      resellersLoading: true,
      resellersError: undefined,
      computerInfo: undefined,
      add_to: {
        username: "",
        email: "",
      },
      user_TEST: {
        first_name: 'massi',
        last_name: 'massi',
        reseller_id: 46083,
        username: 'massi123',
        password: '123123123',
        confirm_password: '123123123',
        company_name: 'test1',
        company_address: '123123',
        company_city: "Altona",
        company_state: "Victoria",
        company_country: "Australia",
        email: 'landi.dev1@gmail.com',
        phone: '0039000123',
        accepted_terms: true,
        accepted_privacy_policy: true,
        LR_user_code: '3784283674',
        supplier_name: 'CARGAS 123',
        company_vat_number: '001122',
      },
      user: {
        first_name: '',
        last_name: '',
        reseller_id: undefined,
        username: '',
        password: '',
        confirm_password: '',
        company_name: '',
        company_address: '',
        company_city: undefined,
        company_state: undefined,
        company_country: undefined,
        email: '',
        phone: '',
        accepted_terms: false,
        accepted_privacy_policy: false,
        LR_user_code: '',
        supplier_name: '',
        company_vat_number: '',
      },
    }
  }  
  componentDidMount() {
    console.log("bearer_value: ", this.props.bearer_value)
    
    if (this.props.bearer_value === "_DEMO_") {
      this.setState({ 
        resellersLoading: false,
        computerInfo: {
          program_name: "_DEMO_",
          user_code: "0000",
        },
        loading: false,
      })
      return
    }
    
    AuthService.getResellerList(this.props.bearer_value).then(data => {
      if (data.is_valid) {
        var i = 1
        var rows = data.rows.map(row => {
          row.row_num = i++
          row.view_text = `${row.company_name} (${row.company_country})`
          return row
        })
        //rows = [ rows[0] ] // tengo solo il primo
        //console.log(rows)
        var reseller_id = (rows.length === 1) ? rows[0].id : undefined          
        console.log("reseller_id", reseller_id)
        this.setState({
          resellersRows: rows,
          resellersLoading: false,
          reseller_id: reseller_id,
        })
      } else {
        //console.log(data)
        this.setState({ 
          resellersLoading: false,
          resellersError: data.message,
        })
      }
    }).catch(e => {
      //console.log(e)
      this.setState({ 
        resellersLoading: false,
        resellersError: "Unknown error",
      })
    })

    AuthService.getComputerInfo(this.props.bearer_value).then(data => {
      if (data.is_valid) {
        console.log(data.payload)
        this.setState({
          computerInfo: data.payload,
          loading: false,
        })
      } else {
        console.log(data)
        this.setState({ 
          errorMessage: data.message,
          loading: false,
        })
      }
    }).catch(e => {
      console.log(e)
      this.setState({ 
        errorMessage: "Unknown error",
        loading: false,
      })
    })
  }
  // funzione per visualizzare un messaggio che poi scompare in automatico
  notifySomething(message, type="success") {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }
  loginForm_btn_submit_click() {
    console.log("LOGIN", this.getUser())
    if (!this.state.reseller_id) {
      this.notifySomething("Please select a reseller", "error");
      return;
    }
    // console.log("this.state.reseller_id", this.state.reseller_id)
    // return
    this.setState({ 
      loading: true,
    })
    AuthService.addComputerToExisting(this.props.bearer_value, this.getUser(), this.state.reseller_id).then(data => {
        
      if (data.is_valid) {
        this.setState({ 
          loading: false,
          completed: true,
        })
      } else {
        console.log("data" , data)
        this.setState({ 
          loading: false,
        })
        this.notifySomething(data.message, "error")
      }
    }).catch(e => {
      console.log(e)
      this.setState({ 
        loading: false,
      })
      this.notifySomething("Unknown error", "error")
    })  
  }
  loginForm_btn_create_account_click() { this.setState({ selectedTabIndex: 1 }) }
  getUser() { return this.state.user; /*return this.state.user_TEST*/ }
  registerForm_btn_submit_click() {
    console.log("REGISTER", this.getUser())  
    if (!this.state.reseller_id) {
      this.notifySomething("Please select a reseller", "error");
      return;
    }
    // console.log("this.state.reseller_id", this.state.reseller_id)
    // return  
    this.setState({ 
      loading: true,
    })
    AuthService.addComputerToNew(this.props.bearer_value, this.getUser(), this.state.reseller_id).then(data => {
      if (data.is_valid) {
        var activation_id = data.activation_id
        this.props.navigate("/computer/verify" + 
          "?b=" + this.props.bearer_value + 
          "&act=" + activation_id)
      } else {
        console.log("data" , data)
        this.setState({ 
          loading: false,
        })
        this.notifySomething(data.message, "error")
      }
    }).catch(e => {
      console.log(e)
      this.setState({ 
        loading: false,
      })
      this.notifySomething("Unknown error", "error")
    })  
  }



  add_to(user) {
    if (!this.state.reseller_id) {
      this.notifySomething("Please select a reseller", "error");
      return;
    }
    // console.log("this.state.reseller_id", this.state.reseller_id)
    // return
    this.setState({ 
      loading: true,
    })
    AuthService.addComputerToUser(this.props.bearer_value, user, this.state.reseller_id).then(data => {        
      if (data.is_valid) {
        this.setState({ 
          loading: false,
          completed: true,
        })
      } else {
        console.log("data" , data)
        this.setState({ 
          loading: false,
        })
        this.notifySomething(data.message, "error")
      }
    }).catch(e => {
      console.log(e)
      this.setState({ 
        loading: false,
      })
      this.notifySomething("Unknown error", "error")
    })
  }
  addToUserForm_btn_add_to_current_user_click() {
    console.log("current_username", this.props.authStatus.user.username)
    this.add_to({ username: this.props.authStatus.user.username })
  }
  addToUserForm_btn_add_to_email_click() {
    console.log("add_to.email", this.state.add_to.email)
    this.add_to({ email: this.state.add_to.email })
  }
  addToUserForm_btn_add_to_username_click() {
    console.log("add_to.username", this.state.add_to.username)
    this.add_to({ username: this.state.add_to.username })
  }



  render() {
    if (this.state.loading) return <LoadingSpinner />
    if (!this.props.authStatus.completed) return <LoadingSpinner />

    if (this.state.completed) {
      return (
        <div className="container-sm">
          <Alert severity="success">
            <AlertTitle>Registration completed</AlertTitle>
            Now you have to wait the email with the license file or contact your reseller.
          </Alert>
        </div>
      )
    }

    if (this.state.errorMessage) {
      return (
        <div className="container-sm">
          <Alert severity="error">
            <AlertTitle>{this.state.errorMessage}</AlertTitle>
            Maybe this user code is already assigned to another user. Contact your reseller if you think there is a mistake.
          </Alert>
        </div>
      )
    }
    
    return (
      <>
        <div>
          <div className="container-sm">
            <Alert severity="info">
              <AlertTitle>Register your copy of {this.state.computerInfo.program_name}</AlertTitle>
              User code: <strong>{this.state.computerInfo.user_code}</strong>
              <Box mt={3}>
                Reseller:
                {this.state.resellersError ? (
                  <p style={{ color: 'red', fontWeight: 'bold', textTransform: 'uppercase' }}>{this.state.resellersError}</p>
                ) : (
                  <SelectBox
                    dataSource={this.state.resellersRows}
                    displayExpr="view_text"
                    valueExpr="id"
                    value={this.state.reseller_id}
                    onValueChanged={(e) => {
                      this.setState({ 
                        reseller_id: e.value 
                      });
                    }}
                    placeholder="Select a reseller"                
                  />
                )}
              </Box>
            </Alert>
          </div>
          <br />
          <div className="container-sm">
            {this.props.authStatus.user ? (

              // UTENTE GIA' LOGGATO
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={this.state.selectedTabIndex}
                    onChange={(e, newValue) => {
                      this.setState({
                        selectedTabIndex: newValue,
                      })                    
                    }} >
                    <Tab label="Add to user" {...a11yProps(0)} />                    
                  </Tabs>
                </Box>
                <TabPanel value={this.state.selectedTabIndex} index={0}>
                  {/* add to user */}
                  <AddToUserComp
                    user={this.props.authStatus.user} 
                    add_to={this.state.add_to} 
                    btn_add_to_current_user_click={this.addToUserForm_btn_add_to_current_user_click.bind(this)}
                    btn_add_to_email_click={this.addToUserForm_btn_add_to_email_click.bind(this)}
                    btn_add_to_username_click={this.addToUserForm_btn_add_to_username_click.bind(this)}                    
                    />
                </TabPanel>                
              </Box>

            ) : (

              // UTENTE NON ANCORA LOGGATO
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={this.state.selectedTabIndex}
                    onChange={(e, newValue) => {
                      this.setState({
                        selectedTabIndex: newValue,
                      })                    
                    }} >
                    <Tab label="Login" {...a11yProps(0)} />
                    <Tab label="Create a new account" {...a11yProps(1)} />
                  </Tabs>
                </Box>
                <TabPanel value={this.state.selectedTabIndex} index={0}>
                  {/* login */}
                  <LoginComp
                    btn_submit_click={this.loginForm_btn_submit_click.bind(this)}
                    btn_create_account_click={this.loginForm_btn_create_account_click.bind(this)}
                    user={this.getUser()}
                    />
                </TabPanel>
                <TabPanel value={this.state.selectedTabIndex} index={1}>
                  {/* create new */}
                  <ServiceUserForm
                    btn_submit_click={this.registerForm_btn_submit_click.bind(this)}
                    newUser={true}
                    isAdmin={false}
                    isReseller={false}
                    readOnly={false}
                    user={this.getUser()}
                    hideAgrees={false}                    
                    />
                </TabPanel>
              </Box>

            )}
          </div>
        </div>
      </>
    )
  }
}
